import { DashboardExtDatasetLoadedNotification, NotificationContentBase } from '../../services/api.services';
import { BasicNotification } from '../models/basic-notification';

export function dashboardExtDatasetLoadedMapping(content: NotificationContentBase, time: string) {
    let dashExtDatasetloaded = <DashboardExtDatasetLoadedNotification>content;
    return <BasicNotification>{
        id: dashExtDatasetloaded.id,
        iconUrl: dashExtDatasetloaded.succesful ? "/assets/img/notification-icons/dashboard-success.svg" : "/assets/img/notification-icons/dashboard-warning.svg",
        pendingUrl: "/assets/img/notification-icons/dashboard-grey.svg",
        color: dashExtDatasetloaded.succesful ? "#6DD400" : "#F29100",
        headline: "Extended Dataset Load",
        title: dashExtDatasetloaded.dashboardName,
        message: dashExtDatasetloaded.succesful ? "has completed successfully" : "failures have been detected",
        buttons: [
            {
                label: "Edit",
                url: `dashboards/${dashExtDatasetloaded.id}/edit`
            },
            {
                label: "View",
                url: `dashboards/${dashExtDatasetloaded.id}`
            }
        ],
        time: time
    };
}
